<template>
	<div class="header">
		<div>
			<router-link tag="a" to="/">
				<img class="logo" :src="this.$store.state.user.navLogo" alt="logo" />
			</router-link>
			<ul class="nav">
				<li :class="{'active':$route.meta.setupType==1}"><router-link tag="a" to="/">首页</router-link></li>
				<li :class="{'active':$route.meta.setupType==111}">
					<i>产品</i>
					<div class="productTabulation">
						<p @click="fillProduct_(domain.partyDomain+'#/home')">数据变现系统</p>
						<p @click="fillProduct('/valuation',true)">数智投资系统</p>
						<p @click="fillProduct(domain.partyDomain+'pptist/#/bp',false)">慧 · bp</p>
					</div>
				</li>
				<li :class="{'active':$route.meta.setupType==7}">
					<i>服务</i>
					<div class="productTabulation">
						<p @click="serverDetails('dataService',1)">数据类服务</p>
						<p @click="serverDetails('equity',1)">股权类服务</p>
						<p @click="serverDetails('businessServices',1)">商情类服务</p>
					</div>
				</li>
				<li :class="{'active':$route.meta.setupType==5}">
					<router-link tag="a" to="/newsInformation">资讯</router-link>
				</li>
				<li :class="{'active':$route.meta.setupType==6}">
					<router-link tag="a" to="/aboutUs">我们</router-link>
				</li>
				<li>
					<div style="display: flex;align-items: center;height: 100%;margin-left: 50px;">
						<div class="index-reg" v-if="$store.state.user.isLogining">
							<span @click="login">登录</span>
							<span style="margin: 0 10px;">|</span>
							<span @click="register">注册</span>
						</div>
						<div v-else class="index-my-container" style="position: relative;">
							<div class="index-my">
								<i class="iconfont icon-wode"></i>
								<span>{{$store.state.user.userName}}</span>
							</div>

							<div class="productTabulation" style="width: 100px;right: 0;transform:translateX(-40px);">
								<p @click="fillProduct('/bpList',true)">我的bp</p>
								<p @click="dropOut">退出</p>
							</div>

						</div>

					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import publicMethod from '@/views/publicMethod'
	import navFooterInfo from './navFooterInfo'

	import {
		eventBus
	} from '@/components/login/eventBus';

	export default {
		mixins: [publicMethod, navFooterInfo],
		data() {
			return {

			}
		},
		mounted() {
			this.isLogining()
			this.getPageSetup()

		},
		methods: {
			login() {
				eventBus.$emit('show-login-dialog');
			},
			register() {
				eventBus.$emit('show-register-dialog');
			},
			dropOut() {
				this.updateAllComponents()
				localStorage.removeItem("userToken");
				localStorage.removeItem("userName");
				this.$router.push({
					path: '/'
				});
			}


		}
	}
</script>
<style scoped lang="less">
	.header {
		width: 100%;
		height: 70px;
		background: #fff;

		>div {
			width: 1200px;
			height: 100%;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;

			.logo {
				height: 60px;
				position: relative;
				top: 5px;
			}

			.nav {
				height: 100%;
				display: flex;
				align-items: center;

				li:not(:last-child) {
					padding: 0 30px;
					line-height: 70px;
				}

				li.active>a,
				li.active>i,
				li:hover>i,
				li:hover>a,
				.productTabulation>p:hover,
				.productTabulation>p:hover a {
					color: var(--mainColor);
				}

				li:hover>.productTabulation,
				.index-my-container:hover .productTabulation {
					display: block;
				}

				li {
					height: 100%;
					font-size: 14px;
					font-weight: 400;
					color: #282828;
					cursor: pointer;
					position: relative;
					z-index: 22;

					>a {
						color: #282828;
					}

					.index-reg {
						width: 104px;
						height: 30px;
						color: var(--mainColor);
						border: 1px solid var(--mainColor);
						line-height: 24px;
						text-align: center;
					}

					.index-my-container:hover .index-my {
						color: var(--mainColor);
					}

					.index-my {
						height: 70px;
						display: flex;
						align-items: center;

						>i {
							font-size: 20px;
						}

						>span {
							max-width: 105px;
							margin-left: 5px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
					}

					.productTabulation {
						// width: 170px;
						width: 127px;
						background: #fff;
						padding: 10px 20px;
						display: none;
						position: absolute;
						top: 62px;
						left: 50%;
						transform: translateX(-50%);

						p {
							line-height: 35px;
						}

						a {
							color: #282828;
						}

					}


				}
			}

		}

	}
</style>